import { SignedInSteps } from '../../../pure-js/types/SignedInTypes'
import SignedIn from '../components/SignedIn'

export const OnboardingPage = () => {
  return <SignedIn defaultStep={SignedInSteps.ONBOARDING} />
}
